import React, { MouseEventHandler, PureComponent } from "react";
import { connect } from "react-redux";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavItem,
} from "reactstrap";
import { NavLink, RouteComponentProps } from "react-router-dom";
import "./NavMenu.css";
import { AnyAction, bindActionCreators } from "redux";
import * as CustomerBillsState from "../store/CustomerBillsReducer";
import * as CABSMaintenanceAction from "../store/CustomerBills";
import * as AuthorizationStore from "../store/AuthorizationReducer";
import * as AuthorizationAction from "../store/AuthorizationAction";
import { ThunkDispatch } from "redux-thunk/es/types";
import { ApplicationState } from "../store";


const logo = require("../images/Frontier_Verizon_Logo_Horiz_Reg_RGB_White.png");
// At runtime, Redux will merge together...
type CABSMaintenanceProps =

  AuthorizationStore.State & // ... state we've requested from the Redux store
  CustomerBillsState.CustomerBillsState & // ... state we've requested from the Redux store
  typeof CABSMaintenanceAction.actionCreators & // ... plus action creators we've requested
  RouteComponentProps<{ appcode: string }> & // ... plus incoming routing parameters
  temp;

interface temp {
  actions: {
    authorizationActions: AnyAction;
    modalActions: AnyAction;
  };
}
export class NavMenu extends PureComponent<CABSMaintenanceProps, { isOpen: boolean, username: string | undefined}> {
  public state = {
    isOpen: false,
    username: undefined,
  };
  toggleControlModal: MouseEventHandler<HTMLButtonElement> | undefined;

  constructor(props: Readonly<CABSMaintenanceProps>) {
    super(props);


    this.toggleControlModal = () => {
      this.props.actions.modalActions.setModalState("CONTROL", true, () => {
        this.forceUpdate();
      });
    };
  }
  public componentDidMount() {
    this.ensureDataFetched();

  }

  private ensureDataFetched() {
    fetch(process.env.REACT_APP_API_HOST + `/CABSBill/user`, {
      method: "GET",
      credentials: "include",
      headers: {
        pragma: "no-cache",
        "cache-control": "no-cache",
        'Authorization': 'Bearer ' + localStorage.getItem("accessToken"),
      },
    })
      .then((response) => response.json() as Promise<string>)
      .then((data) => {

        this.setState({
          username: data
        });

      })
      .catch((error) => {

        this.setState({ username: "" });
      });
  }


  public render() {

    return (
      <div className="navbox">
        <Navbar
          className="navbar-expand-sm navbar-toggleable-sm box-shadow "
          dark
        >
          <>
            <a onClick={this.navclose} href="/cabsbillportal" data-di-id="di-id-74781012-163657f9" style={{ marginLeft: '20px' }}>
              <img src={logo} alt="Frontier Logo" style={{ height: '75px', width: 'auto', maxHeight: '75px' }} />
            </a>

            <NavbarToggler onClick={this.toggle} className="mr-2" />
            <Collapse
              className="d-sm-inline-flex flex-sm-row-reverse"
              isOpen={this.state.isOpen}
              navbar
            >
              <ul className="navbar-nav flex-grow align-items-center">
                {localStorage.getItem("agentAccess") && this.state.username && <h3 className="mr-5">{"Currently logged in as: " + this.state.username}</h3>
                }

                {!window.location.href.includes("login") && (localStorage.getItem("accessToken") === undefined || localStorage.getItem("accessToken") === null) && <NavItem>
                  {/* <NavLink onClick={() => { this.navclose();window.location.href = "/cabsbillportal/login" }} className="text-light" to="/login">
                   */}
                  <a style={{ cursor: "pointer" }} className="text-light" href="/cabsbillportal/login">
                    Sign In/Register
                  </a>
                </NavItem>
                }
                {localStorage.getItem("accessToken") && <NavItem>
                  {/* <NavLink className="text-light" to="/logout"> */}
                  <a style={{ cursor: "pointer" }} className="text-light" onClick={this.logout} >
                    Logout
                  </a>
                </NavItem>
                }
                {window.location.href.includes("login") && (localStorage.getItem("accessToken") === undefined || localStorage.getItem("accessToken") === null) && <NavItem>
                  {/* <NavLink onClick={this.navclose} className="text-light" to="/registration">
                    Sign In/Register
                    </NavLink> */}
                  Sign In/Register
                </NavItem>}

                <div className="ml-5"></div>
                <div className="ml-5"></div>
                <div className="ml-5"></div>
                <div className="ml-5"></div>
                <div className="ml-5"></div>

              </ul>


            </Collapse>
          </>
        </Navbar>
      </div>
    );

  }

  private logout = () => {

    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("agentAccess");
    this.setState({
      isOpen: false,
    });
    window.location.href = "/cabsbillportal/login";
  };
  private navclose = () => {

    this.setState({
      isOpen: false,
    });
  };

  private toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };
}

const mapStateToProps = function (
  state: ApplicationState) {
  //  console.log('ownprops' + ownProps.subgroup);
  // console.log('state' + state.subgroupcompany.subgroupcompany);
  return {
    authorizations: state.authorizationstate
      ? state.authorizationstate.authorizations
      : undefined,
  };
};

function mapDispatchToProps(dispatch: ThunkDispatch<any, any, AnyAction>) {
  return {
    actions: {
      authorizationActions: bindActionCreators(
        AuthorizationAction.actionCreators,
        dispatch
      ),
      modalActions: bindActionCreators(CABSMaintenanceAction.actionCreators, dispatch),
    },
  };
}

export default connect(
  mapStateToProps, // Selects which state properties are merged into the component's props
  mapDispatchToProps // Selects which action creators are merged into the component's props
)(NavMenu as any);
